import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ComboPackageManagment {
  apiBaseUrl = environment.apiBaseUrl;

  constructor(private _httpClient: HttpClient) {}

  get(params: { 'page[number]': number, 'page[size]': number, 'orderBy[modifiedOn]': string, 'searchFilter[name]'?: string,'filter[status]':string, }) {
    return this._httpClient.get(`${this.apiBaseUrl}/comboPackages`, { params });
  }


  getAllEarning(vendorId:any,duration:any,pageNumber:any,pageSize:any,sortField:any,sortOrder:any) {
    return this._httpClient.get(`${this.apiBaseUrl}/bookings/vendor/${vendorId}/${duration}?pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}`,);
  }

  getAllVendorsRevenue(duration:any) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/vendorsRevenue?duration=${duration}`,);
  }

  deleteComboPackageManagment(id: string) {
    return this._httpClient.delete(`${this.apiBaseUrl}/comboPackages/${id}`);
  }

  getComboPackageManagment(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/comboPackages${query}`);
  }

  getComboPackageManagmentById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/comboPackages/${id}`);
  }

  updateComboPackageManagment(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/comboPackages/${id}`, data);
  }

  AddComboPackageManagment(data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/comboPackages`, data);
  }

  getLocations(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/locations${query}`);
  }

  getService(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/services${query}`);
  }

  getStatisticsByServiceId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  toggleReviews(body: any){
    return this._httpClient.post(`${this.apiBaseUrl}/reviews-and-ratings/toggle-dummy-review`, body);
  }

}
